module.exports = __webpack_public_path__ + "static/media/12.a98e00c2.jpg";